import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { IUserBet } from "../../core/round/store/interfaces";
import { combineLatest, distinctUntilChanged, filter, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ERoundState } from "../../core/round/interfaces";
import _isEqual from "lodash/isEqual";
import { GetUserBetByIndexUseCase } from "../../core/round/domain/get-user-bet-by-index.use-case";
import { GetRoundStateUseCase } from "../../core/round/domain/get-round-state.use-case";
import { GetRoundIdUseCase } from "../../core/round/domain/get-round-id.use-case";

@Injectable()
export class GetAutoCashOutUseCase implements IUseCase<number, Observable<IUserBet>> {
    constructor(private getUserBetByIndexUseCase: GetUserBetByIndexUseCase,
                private getRoundStateUseCase: GetRoundStateUseCase,
                private getRoundIdUseCase: GetRoundIdUseCase) {
    }

    execute(betIndex: number): Observable<IUserBet> {
        return combineLatest([this.getUserBetByIndexUseCase.execute(betIndex),
            this.getRoundStateUseCase.execute(), this.getRoundIdUseCase.execute()])
            .pipe(distinctUntilChanged((prev: [IUserBet, ERoundState, string | undefined], curr: [IUserBet, ERoundState, string | undefined]) => {
                return prev[1] === curr[1] && _isEqual(prev[0], curr[0] && prev[2] === curr[2]);
            }), filter(([userBet, roundState, currentRoundId]: [IUserBet, ERoundState, string | undefined]) =>
                    !!(roundState === ERoundState.Playing && !!userBet &&
                        !!userBet.roundId && currentRoundId === userBet.roundId &&
                        userBet.maxMultiplier && userBet.multiplier >= userBet.maxMultiplier)),
                map(([userBet, _roundState, _currentRoundId]: [IUserBet, ERoundState, string | undefined]) => userBet));
    }
}
